import styled from 'styled-components';

export const InterstitialModalMetadataContainer = styled.section`
    padding: 40px;

    .grid-2 {
        font-size: 12px;
    }

    p.bold {
        margin-bottom: 20px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMetaDataComponentStyle.js